import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  DeleteButton,
  TextInput,
} from 'react-admin';
import { ListActions } from '../common';

const GroupFilters = [<TextInput key="name" label="Name" source="name" alwaysOn />];

export const GroupList = () => (
  <List filters={GroupFilters} actions={<ListActions />}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="name" />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
